<script>
import AddButton from "../../../../components/buttons/AddButton.vue"
import ExportInCsvButton from "../../../../components/buttons/ExportInCsvButton"
import SearchBar from '../../../../components/forms/SearchBar.vue'
import Button from '../../../../../Pages/components/buttons/Button.vue'
import { eventBus } from '../../../../../Pages/assets/eventBus.js'

export default {
    components: { 
        AddButton,
        ExportInCsvButton,
        Button,
        SearchBar
    },
    props: {
        addClientClick: Function,
        addInviteClick: Function,
        massAddClientClick: Function,
        exportLoader: Boolean,
        exportDataFetch: Function,
        startDownload: Function,
        finishDownload: Function,
        viewType: String,
        toggleList: Function,
        search: String,
        exportCsvFilename: {
            type: String,
            default: function () {
                return null;
            },
        },
        isShowCreateInviteButton: Boolean,
    },

    data() {
        return {
            searchValue: this.search
        }
    },

    methods: {
        searchFunc() {
            this.$emit('searchUsers', this.searchValue)
            eventBus.manageSortingAtSearchUser()
        },
        searchInputTrigger() {
            this.$refs.searchClick.onClick()
        }
    },
};
</script>

<template>
    <div class="row justify-content-between">
        <div class="col-auto">
            <div class="row">
                <template v-if="isShowCreateInviteButton">
                    <div class="col-auto">
                        <AddButton :onClick="addClientClick" classes="mb-2">Add Client</AddButton>
                    </div>
                    <div class="col-auto">
                        <AddButton :onClick="massAddClientClick" classes="mb-2">Add Mass Clients</AddButton>
                    </div>
                    <div class="col-auto">
                        <AddButton :onClick="addInviteClick" classes="mb-2">Invite Client</AddButton>
                    </div>
                </template>
                <div class="col-auto">
                    <ExportInCsvButton
                        :exportLoader="exportLoader"
                        :exportDataFetch="exportDataFetch"
                        :startDownload="startDownload"
                        :finishDownload="finishDownload"
                        :fileName="exportCsvFilename"
                    />
                </div>
            </div>
        </div>

        <div class="col-auto mt-4 mt-sm-0 float-sm-end d-sm-flex align-items-center">
            <div class="search-box me-2">
                <div class="position-relative">
                    <div class="input-group">
                        <SearchBar
                            v-model="searchValue"
                            type="text"
                            placeholder="Search..."
                            styles="padding-left: 20px"
                            classes="form-control"
                            :searchInputTrigger="searchInputTrigger"
                        />
                        <Button 
                            variant="primary"
                            classes='btn-rounded'
                            :onClick="searchFunc"
                            type="button"
                            ref="searchClick"
                        >
                            <i class="bx bx-search-alt mt-1"></i>
                        </Button>
                    </div>
                </div>
            </div>
            <ul
                class="nav nav-pills product-view-nav justify-content-end mt-3 mt-sm-0"
            >
                <li class="nav-item">
                    <a
                        class="nav-link"
                        href="Javascript:void(0);"
                        :class="{ active: viewType === 'list' }"
                        @click="toggleList"
                    >
                        <i class="bx bx-list-ul"></i>
                    </a>
                </li>
                <li class="nav-item">
                    <a
                        class="nav-link"
                        href="Javascript:void(0);"
                        :class="{ active: viewType === 'grid' }"
                        @click="toggleList"
                    >
                        <i class="bx bx-grid-alt"></i>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>
